export class StatusCategory {
  public id?: string;
  public name: string;
}
